module.exports = __webpack_public_path__ + "static/media/nus_logo.be2b894d.png";